export * from './MicrowaveIcon'
